export const sectorThreat_agriculture_district = [
  {
    "OBJECTID": 1,
    "District": "Buikwe",
    "density": 278.701989,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 2,
    "District": "Bukomansimbi",
    "density": 246.7269424,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 3,
    "District": "Butambala",
    "density": 330.0920316,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Medium",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 4,
    "District": "Buvuma",
    "density": 741.9842607,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Low",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 5,
    "District": "Gomba",
    "density": 825.7095518,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 6,
    "District": "Kalangala",
    "density": 562.349647,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 7,
    "District": "Kalungu",
    "density": 829.8559296,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Medium",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 8,
    "District": "Kampala",
    "density": 146.2998713,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Low",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Low",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 9,
    "District": "Kayunga",
    "density": 339.6236747,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 10,
    "District": "Kiboga",
    "density": 330.6653326,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 11,
    "District": "Kyankwanzi",
    "density": 465.82799,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Medium",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 12,
    "District": "Kyotera",
    "density": 101.9386721,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Low",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 13,
    "District": "Luwero",
    "density": 348.315327,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 14,
    "District": "Lwengo",
    "density": 55.1958761,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 15,
    "District": "Lyantonde",
    "density": 202.0946948,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Medium",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 16,
    "District": "Masaka",
    "density": 590.4628432,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Low",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 17,
    "District": "Mityana",
    "density": 499.4464019,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 18,
    "District": "Mpigi",
    "density": 81.65604474,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 19,
    "District": "Mubende",
    "density": 405.8361725,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Medium",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 20,
    "District": "Mukono",
    "density": 531.3365085,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Low",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Low",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 21,
    "District": "Nakaseke",
    "density": 751.9572014,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 22,
    "District": "Nakasongola",
    "density": 599.855682,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 23,
    "District": "Rakai",
    "density": 104.0111843,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Medium",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 24,
    "District": "Ssembabule",
    "density": 535.0794994,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Low",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 25,
    "District": "Wakiso",
    "density": 718.5253837,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 26,
    "District": "Buhweju",
    "density": 984.416526,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 27,
    "District": "Buliisa",
    "density": 181.3121843,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Medium",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 28,
    "District": "Bundibugyo",
    "density": 140.6369316,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Low",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 29,
    "District": "Bunyangabu",
    "density": 442.9625568,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 30,
    "District": "Bushenyi",
    "density": 243.8655576,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 31,
    "District": "Hoima",
    "density": 401.5005386,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Medium",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 32,
    "District": "Ibanda",
    "density": 361.7020613,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Low",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Low",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 33,
    "District": "Isingiro",
    "density": 538.1157308,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 34,
    "District": "Kabale",
    "density": 215.8308386,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 35,
    "District": "Kabarole",
    "density": 791.4597174,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Medium",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 36,
    "District": "Kagadi",
    "density": 875.5190525,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Low",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 37,
    "District": "Kakumiro",
    "density": 532.6932874,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 38,
    "District": "Kamwenge",
    "density": 545.4792699,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 39,
    "District": "Kanungu",
    "density": 365.7795133,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Medium",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 40,
    "District": "Kasese",
    "density": 727.7312819,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Low",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 41,
    "District": "Kibaale",
    "density": 479.5358175,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 42,
    "District": "Kiruhura",
    "density": 415.0008454,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 43,
    "District": "Kiryandongo",
    "density": 389.4121765,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Medium",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 44,
    "District": "Kisoro",
    "density": 998.1299243,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Low",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Low",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 45,
    "District": "Kyegegwa",
    "density": 363.2044193,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 46,
    "District": "Kyenjojo",
    "density": 453.8568498,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 47,
    "District": "Masindi",
    "density": 376.9167947,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Medium",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 48,
    "District": "Mbarara",
    "density": 474.6967786,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Low",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 49,
    "District": "Mitooma",
    "density": 611.3602363,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 50,
    "District": "Ntoroko",
    "density": 252.6745162,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 51,
    "District": "Ntungamo",
    "density": 809.0357151,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Medium",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 52,
    "District": "Rubanda",
    "density": 17.1238709,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Low",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 53,
    "District": "Rubirizi",
    "density": 62.26057789,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 54,
    "District": "Rukiga",
    "density": 428.0840051,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 55,
    "District": "Rukungiri",
    "density": 110.8227555,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Medium",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 56,
    "District": "Sheema",
    "density": 956.0320918,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Low",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Low",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 57,
    "District": "Abim",
    "density": 69.79888555,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 58,
    "District": "Adjumani",
    "density": 241.4580831,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 59,
    "District": "Agago",
    "density": 780.2698424,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Medium",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 60,
    "District": "Alebtong",
    "density": 570.3996846,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Low",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 61,
    "District": "Amolatar",
    "density": 37.86673467,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 62,
    "District": "Amudat",
    "density": 361.42856,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 63,
    "District": "Amuru",
    "density": 682.3550279,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Medium",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 64,
    "District": "Apac",
    "density": 413.2505362,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Low",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 65,
    "District": "Arua",
    "density": 567.4183613,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 66,
    "District": "Dokolo",
    "density": 478.2181667,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 67,
    "District": "Gulu",
    "density": 430.6618518,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Medium",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 68,
    "District": "Kaabong",
    "density": 14.44178071,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Low",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Low",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 69,
    "District": "Kitgum",
    "density": 572.4692216,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 70,
    "District": "Koboko",
    "density": 127.2397838,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 71,
    "District": "Kole",
    "density": 467.1958852,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Medium",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 72,
    "District": "Kotido",
    "density": 279.4282375,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Low",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 73,
    "District": "Lamwo",
    "density": 175.3618014,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 74,
    "District": "Lira",
    "density": 260.0799977,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 75,
    "District": "Maracha",
    "density": 920.7514765,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Medium",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 76,
    "District": "Moroto",
    "density": 724.1716253,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Low",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 77,
    "District": "Moyo",
    "density": 926.9835872,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 78,
    "District": "Nakapiripirit",
    "density": 812.8971007,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 79,
    "District": "Napak",
    "density": 575.1580426,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Medium",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 80,
    "District": "Nebbi",
    "density": 538.9004306,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Low",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Low",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 81,
    "District": "Nwoya",
    "density": 914.2235399,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 82,
    "District": "Omoro",
    "density": 765.428175,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 83,
    "District": "Otuke",
    "density": 310.9616898,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Medium",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 84,
    "District": "Oyam",
    "density": 357.2156813,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Low",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 85,
    "District": "Pader",
    "density": 614.8050964,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 86,
    "District": "Pakwach",
    "density": 958.2143341,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 87,
    "District": "Yumbe",
    "density": 197.5747566,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Medium",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 88,
    "District": "Zombo",
    "density": 522.0775825,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Low",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 89,
    "District": "Amuria",
    "density": 938.7348769,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 90,
    "District": "Budaka",
    "density": 241.3159907,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 91,
    "District": "Bududa",
    "density": 7.652238837,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Medium",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 92,
    "District": "Bugiri",
    "density": 586.4959576,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Low",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Low",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 93,
    "District": "Bukedea",
    "density": 755.9587083,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 94,
    "District": "Bukwo",
    "density": 364.7058937,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 95,
    "District": "Bulambuli",
    "density": 301.430765,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Medium",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 96,
    "District": "Busia",
    "density": 764.2872735,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Low",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 97,
    "District": "Butaleja",
    "density": 351.4170308,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 98,
    "District": "Butebo",
    "density": 388.6898722,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 99,
    "District": "Buyende",
    "density": 385.992108,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Medium",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 100,
    "District": "Iganga",
    "density": 55.04989145,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Low",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 101,
    "District": "Jinja",
    "density": 671.5442225,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 102,
    "District": "Kaberamaido",
    "density": 292.1208454,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 103,
    "District": "Kaliro",
    "density": 392.8901791,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Medium",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 104,
    "District": "Kamuli",
    "density": 807.5481562,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Low",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Low",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 105,
    "District": "Kapchorwa",
    "density": 930.357614,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 106,
    "District": "Katakwi",
    "density": 886.8347716,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 107,
    "District": "Kibuku",
    "density": 437.3067468,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Medium",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 108,
    "District": "Kumi",
    "density": 556.985089,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Low",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 109,
    "District": "Kween",
    "density": 128.6331524,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 110,
    "District": "Luuka",
    "density": 108.651427,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 111,
    "District": "Manafwa",
    "density": 322.8774749,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Medium",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 112,
    "District": "Mayuge",
    "density": 74.18240853,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Low",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 113,
    "District": "Mbale",
    "density": 306.2670673,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 114,
    "District": "Namayingo",
    "density": 248.4473435,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 115,
    "District": "Namisindwa",
    "density": 538.5570551,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "Medium",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 116,
    "District": "Namutumba",
    "density": 698.4758858,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Low",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Low",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 117,
    "District": "Ngora",
    "density": 895.7735752,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "High",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "High",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 118,
    "District": "Pallisa",
    "density": 711.2220162,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 119,
    "District": "Serere",
    "density": 357.3681796,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "Medium",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "Medium",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  },
  {
    "OBJECTID": 120,
    "District": "Sironko",
    "density": 191.1727701,
    "flood2020threat": "Low",
    "flood2030threat": "Low",
    "flood2050threat": "Low",
    "drought2020threat": "Low",
    "drought2030threat": "Low",
    "drought2050threat": "Low",
    "heatwave2020threat": "Low",
    "heatwave2030threat": "Low",
    "heatwave2050threat": "Low",
    "landslide2020threat": "Low",
    "landslide2030threat": "Low",
    "landslide2050threat": "Low"
  },
  {
    "OBJECTID": 121,
    "District": "Soroti",
    "density": 373.9709216,
    "flood2020threat": "High",
    "flood2030threat": "Medium",
    "flood2050threat": "High",
    "drought2020threat": "Medium",
    "drought2030threat": "Medium",
    "drought2050threat": "Medium",
    "heatwave2020threat": "High",
    "heatwave2030threat": "Medium",
    "heatwave2050threat": "High",
    "landslide2020threat": "Medium",
    "landslide2030threat": "Medium",
    "landslide2050threat": "Medium"
  },
  {
    "OBJECTID": 122,
    "District": "Tororo",
    "density": 446.742406,
    "flood2020threat": "Medium",
    "flood2030threat": "High",
    "flood2050threat": "High",
    "drought2020threat": "High",
    "drought2030threat": "High",
    "drought2050threat": "High",
    "heatwave2020threat": "Medium",
    "heatwave2030threat": "High",
    "heatwave2050threat": "High",
    "landslide2020threat": "High",
    "landslide2030threat": "High",
    "landslide2050threat": "High"
  }
]